import Radio from "backbone.radio";

import { useEffect } from "react";
import { RequestsRedux } from "administrator/features/requests/requests";
import { REQUESTS_SET_STATE_FROM_URL } from "common/actions/requests";

import { AuthRoute, useRouteMatch, useParams } from "extensions/react-router";

export function RequestsRouter() {
    const { url } = useRouteMatch();
    return (
        <AuthRoute path={`${url}/requests/:section?/:qualifiers?`} component={RequestsComponent} />
    );
}

function RequestsComponent() {
    const { section, qualifiers } = useParams();

    useEffect(() => {
        REQUESTS_SET_STATE_FROM_URL({
            qualifiers,
            section
        });

        Radio.channel("main").request("show:app:view", <RequestsRedux />, {
            name: "Requests",
            waitForAttach: true,
            asyncHeaderBar(cb) {
                return cb({
                    name: "Requests",
                    dates: "now-2w/d_now",
                    datePickerId: "requests"
                });
            }
        });
    }, [section, qualifiers]);

    return null;
}
